<template>
  <div class="scrolled-info">
    <div v-if="state === 'loading'" class="image-placeholder animated-background"></div>
    <div v-else class="image"></div>

    <div v-if="state === 'loading'" class="quest-name-placeholder animated-background"></div>
    <div v-else  class="quest-name"><div class="font-gradient">{{quizData.title}}</div></div>

    <div v-if="state === 'loading'" class="content-text-placeholder animated-background"></div>
    <MarkdownText :text="quizData.introText" />
  </div>

  <div v-if="state !== 'loading'" class="content-footer">
    <div v-if="! authorized">
      <AuthorizationComponent
          auth-prefix="quest"
          show-guest-button
          @authorizedSuccess="authorizedSuccess"
      />
    </div>
    <button
        v-else
        v-on:click="tryToStartQuiz"
    >
      {{quizData.startButtonText}}
    </button>
  </div>
  <QuestionDialog
      v-if="showDialogForTeamName"
      title="Название команды"
      text="Это соревнование - командное. Введите, пожалуйста, название вашей команды в том виде, в каком вы указывали его в заявке на участие."
      :buttons="teamNameDialogButtons"
      :inputRegex="teamNameRegex"
      @hide="showDialogForTeamName = false"
      @action="saveTeamNameAndStartQuest"

  />
</template>

<script>
import AuthorizationComponent from "../authorization/AuthorizationComponent.vue";
import {apiCall, getImageUriOrDefault, metrikaEvent} from "@/common-functions";
import MarkdownText from "@/components/quest/commonPageElements/MarkdownText.vue";
import QuestionDialog from "@/components/quest/commonPageElements/QuestionDialog.vue";

export default {
  components: {
    QuestionDialog,
    AuthorizationComponent,
    MarkdownText,
  },
  props: {
    questId: String,
  },
  emits: ['startQuiz', 'alreadyFinishedQuiz', 'setheadervalues'],
  data() {
    return {
      state: 'loading',
      authorized: false,
      quizData: {
        titleColor: null,
        startImageUrl: null,
        introText: '',
      },
      hasActiveQuestSession: null,
      gameMechanics: null,
      teamNameDialogButtons: [
        {
          text: 'Начать квест',
          id: 'ok',
        }
      ],
      showDialogForTeamName: false,
      teamNameRegex: /^.{3,}$/,
    };
  },

  computed: {
    cssImageUrl() {
      return 'url("' + getImageUriOrDefault(this.quizData.startImageUrl) + '")';
    }
  },

  methods: {

    quizIsStarted() {

    },
    doStartQuizWithApi(teamName) {
      return apiCall('/quest/' + encodeURIComponent(this.questId) + '/startSession',
          {
            method: 'POST',
            body: JSON.stringify({teamName}),
            headers: {
              'content-type': 'application/json'
            }
          }
      )
          .then(response => {
            if (response.ok) {
              metrikaEvent('startquest-'+this.questId);
              return response.json();
            }
            throw new Error('Error starting quest session');
          })
          .then(() => {
            metrikaEvent('resumequest-'+this.questId);
            self.hasActiveQuestSession = true;
            this.$emit('startQuiz', this.gameMechanics);
          });
    },

    tryToStartQuiz() {
      const self = this;
      if (self.hasActiveQuestSession === false) {
        if (self.quizData.needTeamName) {
          self.showDialogForTeamName = true;
        } else {
          self.doStartQuizWithApi();
        }
      } else if (self.hasActiveQuestSession !== null) {
        metrikaEvent('resumequest-'+this.questId);
        this.$emit('startQuiz', this.gameMechanics);
      }
    },
    authorizedSuccess(userData) {
      console.log('Authorization data:', userData)
      this.authorized = userData;
      this.checkHasActiveSession();
    },
    checkHasActiveSession() {
      const self = this;
      apiCall('/quest/' + encodeURIComponent(this.questId) + '/getActiveSession')
          .then(response => {
            if (response.ok) {
              return response.json();
            }
            throw new Error('Error fetching quest sessions');
          })
          .then(json => {
            self.hasActiveQuestSession = json.sessionIsStarted;
            self.gameMechanics = json.gameMechanics;
            if (json.allQuestionsAnswered) {
              this.$emit('alreadyFinishedQuiz');
            } else if (self.hasActiveQuestSession) {
              this.tryToStartQuiz(null);
            }
          });
    },


    saveTeamNameAndStartQuest(buttonId, text) {
      if (text.match(this.teamNameRegex)) {
        this.doStartQuizWithApi(text);
        this.showDialogForTeamName = false;
      }
    },
  },
  created() {
    apiCall('/public/quest/' + encodeURIComponent(this.questId))
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Error fetching quest');
        })
        .then(json => {
          console.log(json);
          this.quizData = json;
          this.state = 'loaded';

          this.$emit('setheadervalues', {
            rest: json.questionCount
          });

          metrikaEvent('questinfo-'+this.questId);
        })
        .catch(e => {
          metrikaEvent('error-questinfo-'+this.questId);
          console.error(e);
          //todo catch 404
        });
  }
}
</script>

<style scoped>
@import '@/scss/loading-animation.scss';

.image {
  width: 100%;
  flex: 1;
  background-image: v-bind('cssImageUrl');
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 45%;
}

.image-placeholder {
  width: 100%;
  flex: 1;
  background-size: cover;
}

.quest-name {
  min-height: 60px;
  background-color: #333333;
  width: 100%;
  justify-content: center;
  display: flex;
  align-items: center;
  font-size: 26px;
  text-align: center;
  line-height: 1.2;
}

.content-footer {
  width: 100%;
  height: 72px;
  background-color: #333333;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.content-text {
  overflow-y: visible;
}

.scrolled-info {
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  flex: 1;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 100%;
}

@media (max-width: 375px) {
  .quest-name {
    font-size: 22px;
  }
  button {
    font-size: 18px;
  }
  .content-footer {
    height: 45px;
  }
}

</style>